/**
 * Card component.
 */

import clsx from 'clsx'

interface CardProps {
  children: React.ReactNode
  className?: string
  onClick?: () => void
}

export function Card({ children, className, onClick }: CardProps) {
  return (
    <div
      className={clsx(
        'bg-tg-section rounded-xl',
        onClick && 'tap-highlight-transparent cursor-pointer active:opacity-80 transition-opacity',
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  )
}
